import { render, staticRenderFns } from "./disc_detail.vue?vue&type=template&id=39bc5eae&"
import script from "./disc_detail.vue?vue&type=script&lang=js&"
export * from "./disc_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports